import {Tabs} from '@mantine/core';
import {cn} from '../../../../../../lib/classname';
import {TabButton} from './TabButton';
import {TabMenu} from './TabMenu';
import {
  NAVIGATION_MENU,
  NAV_VALUE,
  type NavValueType,
  type NavigationMenuType,
} from './constants';

type Props = {
  navValue: NavValueType;
  setNavValue?: (value: NavValueType) => void;
  handleOpenModal?: () => void;
};

export const NavigationForPC: React.FC<Props> = ({
  navValue,
  setNavValue,
  handleOpenModal,
}) => {
  return (
    <Tabs value={navValue} unstyled>
      <div className="flex justify-center mb-24">
        <div className="relative w-[320px] min-w-0">
          <div
            className={cn(
              'absolute top-1/2 left-0 z-0 transition-all duration-700 ease-in-out',
              'transform -translate-y-1/2',
              'bg-white rounded-full w-full h-[44px]',
            )}
          />
          <Tabs.List className="flex bg-transparent relative w-full min-w-0">
            <div
              className={cn(
                'absolute top-1/2 left-0 z-10 transition-all duration-700 ease-in-out -translate-y-1/2 bg-primary',
                'w-1/2 h-[44px] rounded-full',
                navValue === NAV_VALUE.RECOMMEND
                  ? 'translate-x-0'
                  : 'translate-x-full',
              )}
            />
            {NAVIGATION_MENU.map((menu: NavigationMenuType) => (
              <TabButton
                key={menu.value}
                value={menu.value}
                active={navValue === menu.value}
                onClick={() => {
                  if (
                    menu.value === NAV_VALUE.MY_PAGE &&
                    !setNavValue &&
                    handleOpenModal
                  ) {
                    handleOpenModal();
                  }
                  if (menu.value === NAV_VALUE.MY_PAGE) {
                    location.href = '/mypage';
                  }
                  if (menu.value === NAV_VALUE.RECOMMEND) {
                    location.href = '/';
                  }
                }}
                name={menu.name}
              />
            ))}
          </Tabs.List>
        </div>
      </div>

      {NAVIGATION_MENU.map((menu: NavigationMenuType) => (
        <Tabs.Panel key={menu.value} value={menu.value}>
          <TabMenu menu={menu.items} />
        </Tabs.Panel>
      ))}
    </Tabs>
  );
};
